import { VideoCall } from '@shared/ui'
import { useParams } from 'react-router-dom'

export const Meet = () => {
  const { token, room } = useParams()

  return <VideoCall token={token} roomName={room} />
}
